const template_button_cols = {
  md: 4,
  lg: 2,
};

export const fedfKommunikation = {
  formdefinition: [
    {
      control: "switch",
      name: "intern",
      label: "Intern",
      help: "für VN nicht sichtbar",
      cols: {
        md: 4,
        lg: 2,
      },
      default: false,
    },
    {
      control: "switch",
      name: "an_versicherer",
      label: "an VR",
      cols: {
        md: 4,
        lg: 2,
      },
      default: false,
    },
    {
      control: "blank",
      cols: {
        md: 0,
        lg: 2,
      },
    },
    {
      control: "emailinput",
      name: "an_weitere",
      label: "weitere Empfänger",
      cols: "12",
      valid: "isEqualOther('an_versicherer', true) || isNotEmpty(item)",
      help: 'Wählen Sie entweder "an VR"  aus oder geben Sie einen oder mehrere Empfänger-E-Mail-Adressen ein.',
    },

    // text template buttons

    {
      control: "fillbutton",
      label: "Schadennummer",
      cols: template_button_cols,
      actions: [
        {
          method: "fill",
          target: "beschreibung",
          value:
            "Sehr geehrte Damen und Herren,\n\nwir haben Ihre Schadenmeldung erhalten und bearbeiten diese unter {schaden_nummer_accredo}.\nBei Fragen stehen wir Ihnen gern zur Verfügung.",
        },
        {
          method: "fill",
          target: "betreff",
          value: "# {schaden_nummer_accredo}",
        },
      ],
    },
    {
      control: "fillbutton",
      label: "Weiterleitung an VR",
      cols: template_button_cols,
      hidden: "isEqualOther('an_versicherer', true)",
      actions: [
        {
          method: "fill",
          target: "beschreibung",
          value:
            "Sehr geehrte Damen und Herren,\n\nwir haben die Schadenunterlagen geprüft und diese zur weiteren Bearbeitung an Ihren Versicherer weitergeleitet.\nBei Fragen stehen wir Ihnen gern zur Verfügung. ",
        },
        {
          method: "fill",
          target: "betreff",
          value:
            "Vertrag {vertragsnummer} – Schadennr.: {schaden_nummer_vu}, Unsere Schadennr.: {schaden_nummer_accredo}",
        },
      ],
    },
    {
      control: "fillbutton",
      label: "Freigabe",
      cols: template_button_cols,
      hidden: "isEqualOther('an_versicherer', true)",
      actions: [
        {
          method: "fill",
          target: "beschreibung",
          value:
            "Sehr geehrte Damen und Herren,\n\ndie eingereichten Kostenvoranschläge zu dem o.g. Schadenfall wurden durch Ihren Versicherer zur Ausführung freigegeben.\nBitte reichen Sie uns die Rechnung ein, sobald die Arbeiten ausgeführt wurden.\nBei Fragen stehen wir Ihnen gern zur Verfügung. ",
        },
        {
          method: "fill",
          target: "betreff",
          value:
            "Vertrag {vertragsnummer} – Schadennr.: {schaden_nummer_kd} Unsere Schadennr. {schaden_nummer_accredo}",
        },
      ],
    },
    {
      control: "fillbutton",
      label: "Zahlungsmitteilung",
      cols: template_button_cols,
      hidden: "isEqualOther('an_versicherer', true)",
      actions: [
        {
          method: "fill",
          target: "beschreibung",
          value:
            "Sehr geehrte Damen und Herren,\n\nwir haben Ihnen heute zu dem o.g. Schadenfall {schadenzahlung} für die folgenden {rechnungen} überwiesen und den Schaden geschlossen\nBei Fragen stehen wir Ihnen gern zur Verfügung. ",
        },
        {
          method: "fill",
          target: "betreff",
          value:
            "Vertrag {vertragsnummer} – Schadennr.: {schaden_nummer_kd} Unsere Schadennr. {schaden_nummer_accredo}",
        },
      ],
    },
    {
      control: "fillbutton",
      label: "Ablehnung",
      cols: template_button_cols,
      hidden: "isEqualOther('an_versicherer', true)",
      actions: [
        {
          method: "fill",
          target: "beschreibung",
          value:
            "Sehr geehrte Damen und Herren,\n\nwir kommen zurück auf den o.g. Schadenfall\nNach Prüfung der uns vorliegenden Unterlagen besteht in diesem Fall kein Versicherungsschutz.\nSofern Ihnen weitere Informationen/Unterlagen vorliegen, stellen Sie uns diese bitte zur weiteren Prüfung zur Verfügung.\nBei Fragen stehen wir Ihnen gern zur Verfügung. ",
        },
        {
          method: "fill",
          target: "betreff",
          value:
            "Vertrag {vertragsnummer} – Schadennr.: {schaden_nummer_kd} Unsere Schadennr. {schaden_nummer_accredo}",
        },
      ],
    },
    {
      control: "fillbutton",
      label: "Versicherer",
      cols: template_button_cols,
      hidden: "isEqualOther('an_versicherer', false)",
      actions: [
        {
          method: "fill",
          target: "beschreibung",
          value:
            "Sehr geehrte Damen und Herren,\n\nim Anhang beigefügt erhalten Sie eine Neuschadenmeldung zu dem Vertrag {vertragsnummer} nebst der folgenden Unterlagen\n{anlagen}\n{kosten}\nWir bitten um Ihre Prüfung sowie Freigabe der eingereichten Kostenvoranschläge.\nWir bitten um Regulierung auf das folgende Konto {konto}\nBei Fragen stehen wir Ihnen gern zur Verfügung. ",
        },
        {
          method: "fill",
          target: "betreff",
          value:
            "Vertrag {vertragsnummer} – Schadennr.: {schaden_nummer_vu}, Unsere Schadennr.: {schaden_nummer_accredo}",
        },
      ],
    },

    {
      control: "fillbutton",
      label: "Neuschadenmeldung mit KVA an VR",
      cols: template_button_cols,
      hidden: "isEqualOther('an_versicherer', false)",
      actions: [
        {
          method: "fill",
          target: "beschreibung",
          value:
            "Sehr geehrte Damen und Herren,\n" +
            "\n" +
            "beigefügt erhalten Sie eine Neuschadenmeldung zum o.g. Objekt nebst eines Angebotes mit der Bitte um Prüfung sowie Freigabe. \n" +
            "{kosten}\n" +
            "Gern erhalten wir Ihre Schadennummer vorab. \n" +
            "\n" +
            "Für Fragen stehen wir Ihnen gern zur Verfügung und danken für Ihre freundliche Unterstützung",
        },
        {
          method: "fill",
          target: "betreff",
          value:
            "Neuschadenmeldung {schaden_sparte} vom {schaden_datum} Vertrag {vertragsnummer} – S-Ort: {objekt_adresse} - Unsere Schadennummer: {schaden_nummer_accredo}",
        },
      ],
    },

    {
      control: "fillbutton",
      label: "Neuschadenmeldung B&O-Schäden an VR",
      cols: template_button_cols,
      hidden: "isEqualOther('an_versicherer', false)",
      actions: [
        {
          method: "fill",
          target: "beschreibung",
          value:
            "Sehr geehrte Damen und Herren,\n" +
            "\n" +
            "beigefügt erhalten Sie eine Rechnung der Firma B&O i.H.v. € … mit der Bitte um Regulierung auf unser Schadenkonto Nr. DE38 2005 0550 1238 2139 51.\n" +
            "\n" +
            "Als Schadenursache wird „... ... ...“ benannt. \n" +
            "\n" +
            "Wir bitten um Angabe unserer Schadennummer {schaden_nummer_accredo} bei der Regulierung sowie der geführten Korrespondenz zu dem Schaden ausschließlich über unser Haus.\n" +
            "{kosten}\n" +
            "Wir bitten um Mitteilung Ihrer Schadennummer.\n" +
            "\n" +
            "Für Fragen stehen wir Ihnen gern zur Verfügung und danken für Ihre freundliche Unterstützung.",
        },
        {
          method: "fill",
          target: "betreff",
          value:
            "Neuschadenmeldung {schaden_sparte} vom {schaden_datum} – Vertrag {vertragsnummer} – S-Ort: {objekt_adresse} - Unsere Schadennr: {schaden_nummer_accredo}",
        },
      ],
    },

    {
      control: "fillbutton",
      label: "Großschadenmeldung an VR",
      cols: template_button_cols,
      hidden: "isEqualOther('an_versicherer', false)",
      actions: [
        {
          method: "fill",
          target: "beschreibung",
          value:
            "Sehr geehrte Damen und Herren,\n" +
            "\n" +
            "beigefügt erhalten Sie eine Neuschadenmeldung zum o.g. Vertrag mit der Bitte um Prüfung und weitere Bearbeitung.\n" +
            "Der Schadenfall wird aktuell auf mind. 00.000,00€ geschätzt, wir bitten daher um schnellstmögliche Begutachtung des Schadens vor Ort.\n" +
            "Das komplette Objekt ist aktuell nicht bewohnbar, da sämtliche Versorgungsleitungen im Keller durch den Brand beschädigt wurden.\n" +
            "Zur Terminvereinbarung wenden Sie sich bitte an …….\n" +
            "{kosten}\n" +
            "Gern erhalten wir Ihre Schadennummer vorab. \n" +
            "\n" +
            "Für Fragen stehen wir Ihnen gern zur Verfügung und danken für Ihre freundliche Unterstützung.",
        },
        {
          method: "fill",
          target: "betreff",
          value:
            "Neuschadenmeldung {schaden_sparte} vom {schaden_datum} – Vertrag {vertragsnummer} – S-Ort: {objekt_adresse} - Unsere Schadennr.: {schaden_nummer_accredo}",
        },
      ],
    },

    {
      control: "fillbutton",
      label: "Anforderung weiterer Unterlagen bei VN",
      cols: template_button_cols,
      hidden: "isEqualOther('an_versicherer', true)",
      actions: [
        {
          method: "fill",
          target: "beschreibung",
          value:
            "Sehr geehrte Damen und Herren,\n" +
            "\n" +
            "Ihre Schadenmeldung haben wir erhalten.\n" +
            "Zur weiteren Bearbeitung übersenden Sie uns bitte noch die folgenden Unterlagen:\n" +
            "\n" +
            "1. ...\n" +
            "2. ...\n" +
            "3. ...\n" +
            "\n" +
            "Für Fragen stehen wir Ihnen gern zur Verfügung und danken für Ihre freundliche Unterstützung.",
        },
        {
          method: "fill",
          target: "betreff",
          value:
            "Vertrag {vertragsnummer} – Schadennr.: {schaden_nummer_kd} Unsere Schadennr. {schaden_nummer_accredo}",
        },
      ],
    },

    {
      control: "fillbutton",
      label: "Freigabe bei VN",
      cols: template_button_cols,
      hidden: "isEqualOther('an_versicherer', true)",
      actions: [
        {
          method: "fill",
          target: "beschreibung",
          value:
            "Sehr geehrte Damen und Herren,\n" +
            "\n" +
            "der eingereichte Kostenvoranschlag der Firma … in Höhe von …€ wurde vom Versicherer freigegeben.\n" +
            "Bitte reichen Sie uns zu gegebener Zeit die entsprechende Rechnung ein. \n" +
            "\n" +
            "Für Fragen stehen wir Ihnen gern zur Verfügung und danken für Ihre freundliche Unterstützung.",
        },
        {
          method: "fill",
          target: "betreff",
          value:
            "Vertrag {vertragsnummer} – Schadennr.: {schaden_nummer_kd} Unsere Schadennr. {schaden_nummer_accredo}",
        },
      ],
    },

    {
      control: "fillbutton",
      label: "KVA an VR zur Prüfung",
      cols: template_button_cols,
      hidden: "isEqualOther('an_versicherer', false)",
      actions: [
        {
          method: "fill",
          target: "beschreibung",
          value:
            "Sehr geehrte Damen und Herren,\n" +
            "\n" +
            "anbei erhalten Sie einen Kostenvoranschlag zum o.g. Schaden mit der Bitte um Prüfung und Freigabe.\n" +
            "{kosten}\n" +
            "Für Fragen stehen wir Ihnen gern zur Verfügung und danken für Ihre freundliche Unterstützung.",
        },
        {
          method: "fill",
          target: "betreff",
          value:
            "Vertrag {vertragsnummer} – Schadennr.: {schaden_nummer_vu}, Unsere Schadennr.: {schaden_nummer_accredo}",
        },
      ],
    },
    {
      control: "fillbutton",
      label: "Rechnung an VR",
      cols: template_button_cols,
      hidden: "isEqualOther('an_versicherer', false)",
      actions: [
        {
          method: "fill",
          target: "beschreibung",
          value:
            "Sehr geehrte Damen und Herren,\n" +
            "\n" +
            "beigefügt erhalten Sie eine Rechnung der Firma …. i.H.v. € ….. mit der Bitte um Prüfung und Regulierung auf unser Schadenkonto Nr. DE38 2005 0550 1238 2139 51.\n" +
            "\n" +
            "Wir bitten um Angabe unserer Schadennummer {schaden_nummer_accredo} bei der Regulierung sowie der geführten Korrespondenz zu dem Schaden ausschließlich über unser Haus.\n" +
            "{kosten}\n" +
            "Für Fragen stehen wir Ihnen gern zur Verfügung und danken für Ihre freundliche Unterstützung.",
        },
        {
          method: "fill",
          target: "betreff",
          value:
            "Vertrag {vertragsnummer} – Schadennr.: {schaden_nummer_vu}, Unsere Schadennr. {schaden_nummer_accredo}",
        },
      ],
    },
    {
      control: "fillbutton",
      label: "ZM an VN",
      cols: template_button_cols,
      hidden: "isEqualOther('an_versicherer', true)",
      actions: [
        {
          method: "fill",
          target: "beschreibung",
          value:
            "Sehr geehrte Damen und Herren,\n" +
            "\n" +
            "wir haben heute eine Zahlung in Höhe von …….€ auf das Konto ……. veranlasst.\n" +
            "Die Zahlung setzt sich wie folgt zusammen:\n" +
            "\n" +
            "...\n" +
            "\n" +
            "Für Fragen stehen wir Ihnen gern zur Verfügung und danken für Ihre freundliche Unterstützung.\n",
        },
        {
          method: "fill",
          target: "betreff",
          value:
            "Vertrag {vertragsnummer} – Schadennr.: {schaden_nummer_kd} Unsere Schadennr. {schaden_nummer_accredo}",
        },
      ],
    },

    //  communication: subject, body
    {
      control: "input",
      name: "betreff",
      label: "Betreff",
      cols: "12",
      valid: "isNotEmpty(item)",
    },

    {
      control: "textarea",
      name: "beschreibung",
      label: "Beschreibung",
      rows: "12",
      cols: "12",
      valid: "isNotEmpty(item)",
    },
    {
      control: "autocomplete",
      name: "anlagen",
      label: "Anlagen",
      multiple: true,
      cols: "12",
      canPreview: true,
      get_api: {
        target: "options",
        method: "get",
        endpoint: '"data/anlages_select/"+getValue("schaden_id")',
        eval_endpoint: true,
      },
    },
    {
      control: "info",
      label:
        "Hinweis: die Platzhalter werden beim Speichern automatisch ersetzt. Beim Versand per E-Mail wird außerdem automatisch eine E-Mail Signatur hinzugefügt.",
    },
  ],
  transformOut: [],
};
